import { Box, BoxProps, keyframes } from '@chakra-ui/react';
import { rem } from 'polished';

const LTR = keyframes`
  from { transform: translate3d(-66.6%, 0, 0) }
  to   { transform: translate3d(0, 0, 0) }
`;

const BASE = [
  '#D36F58', // red
  '#E2C267', // orange
  '#E9E76E', // yellow
  'transparent',
  '#6095C2', // light blue
  '#3F5FA7', // dark blue
  'transparent',
  '#E9E76E', // yellow
  '#6095C2', // light blue
  '#D36F58', // red
];

const GRADIENT = [...BASE];

export const ProminentButtonGlow = (boxProps: BoxProps) => (
  <Box
    display="block"
    pointerEvents="none"
    borderRadius="inherit"
    width="100%"
    height="75%"
    mixBlendMode="darken"
    opacity={0}
    filter={`blur(${rem(20)})`}
    transition="opacity 550ms, transform 330ms"
    overflow="hidden"
    sx={{
      'button:hover > &, a:hover > &': {
        opacity: 0.5,
        transform: 'translate3d(0, 62.5%, 0)',
      },
    }}
    _after={{
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '300%',
      height: '100%',
      background: `linear-gradient(90deg, ${GRADIENT.join(',')})`,
      backgroundSize: '66.6%',
      animation: `${LTR} 6.5s linear infinite`,
    }}
    {...boxProps}
  />
);
